import envConfig from './envConfig';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: envConfig('firebaseApiKey'),
  authDomain: envConfig('firebaseAuthDomain'),
  projectId: envConfig('firebaseProjectId'),
  storageBucket: envConfig('firebaseStorageBucket'),
  messagingSenderId: envConfig('firebaseSenderId'),
  appId: envConfig('firebaseAppId'),
  measurementId: envConfig('firebaseMeasureId')
};

export const EnableCouponRemoteConfig = 'EnableCoupon';

// Initialize Firebase App
export const getFirebaseApp = async () => {
  const { initializeApp, getApps, getApp } = await import('firebase/app');
  return !getApps().length
    ? initializeApp(firebaseConfig, 'firebaseApp')
    : getApp('firebaseApp');
};

export const getFirebaseAuth = async () => {
  const app = await getFirebaseApp();
  const { getAuth, GoogleAuthProvider, OAuthProvider } =
    await import('firebase/auth');
  return {
    auth: getAuth(app),
    googleProvider: new GoogleAuthProvider(),
    appleProvider: new OAuthProvider('apple.com')
  };
};

export const getFirebaseRemoteConfig = async () => {
  const app = await getFirebaseApp();
  const { getRemoteConfig } = await import('firebase/remote-config');
  const remoteConfig = getRemoteConfig(app);

  remoteConfig.settings = {
    minimumFetchIntervalMillis: 3600000, // How often to allow fetches from firebase (1 hour)
    fetchTimeoutMillis: 10000 // 10 seconds timeout (adjust as needed)
  };

  remoteConfig.defaultConfig = {
    EnableCoupon: JSON.stringify({
      enable: false,
      coupon_code: '',
      discount_percentage: 0
    })
  };

  return remoteConfig;
};
